import type { PropsWithChildren } from "react";

export interface LayoutInfoProps {
	type: string;
	name: string;
}

export function LayoutInfo({ name, type, children }: PropsWithChildren<LayoutInfoProps>) {
	return (
		<>
			<div data-layout-name={name} data-layout-type={type} style={{ display: "none" }} />
			{children}
		</>
	);
}
